import { render } from "./ReporteRecaudosView.vue?vue&type=template&id=3c0e451a"
import script from "./ReporteRecaudosView.vue?vue&type=script&lang=js"
export * from "./ReporteRecaudosView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__